import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogClose, DialogFooter } from "@/components/ui/dialog";
import type { Incident } from "@/app/pages/auditcentre/index";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useTenancy } from "@/contexts/TenancyContext";

export function IncidentDetailDialog({ open, onOpenChange, incident }: { open: boolean; onOpenChange: (open: boolean) => void; incident: Incident | null }) {
  const { userIdToName } = useTenancy();
  if (!incident) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className={`max-w-3xl! w-full max-h-[90vh] overflow-y-auto rounded-xl shadow-lg border border-white/10 p-0!`} aria-describedby={undefined}>
        <div className="flex flex-col gap-4 h-full bg-card">
          <div className="sticky top-0 z-20 py-6 border-b px-4 border-white/10 bg-gradient-to-b from-primary/5 to-transparent backdrop-blur supports-[backdrop-filter]:bg-white/60">
            <DialogTitle className="text-foreground">Incident Details</DialogTitle>
            <DialogDescription>ID: {(typeof incident.id === 'string' || typeof incident.id === 'number') ? incident.id : 'Generating - Check Back Later'}</DialogDescription>
          </div>
        <div className="flex flex-col gap-2 px-4 pb-4">
          <div><b>Status:</b> <Badge variant={incident.status === "Open" ? "destructive" : "success"}>{incident.status}</Badge></div>
          <div><b>Owner:</b> {
  // Defensive: prevent React child error if owner is an object
  typeof incident.owner === 'string'
    ? (userIdToName[incident.owner] === "" || userIdToName[incident.owner] === undefined
        ? incident.owner
        : userIdToName[incident.owner])
    : '[invalid owner]'
}</div>
          <div><b>Summary:</b> {incident.summary}</div>
        </div>
        <DialogFooter className="mt-4 p-4 sticky bottom-0 z-20 border-white/10 bg-gradient-to-t from-primary/5 to-transparent backdrop-blur supports-[backdrop-filter]:bg-white/60 border-t flex! flex-row! justify-between! items-center! align-center! gap-2">
          <DialogClose asChild>
            <Button variant="outline">Close</Button>
          </DialogClose>
        </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
